<template lang="pug">
  app-entity(
    @close="$emit('close', instance)",
    v-bind="{ ...$props, selector: false }",
    :path="path",
    :entity="$findEntity('TriggerAction')",
    :replasable="false",
    :selector="false"
  )

</template>
<script>
import EntityMixin from '@/mixins'
export default {
  mixins: [EntityMixin],
  props: {
    chips: {
      type: Boolean,
      default: true
    },
    entity: {
      type: Object,
      default: () => ({}),
    },
    parent: {
      type: Object,
      default: () => ({})
    },
    parentInstance: {
      type: Object,
      default: () => ({})
    },
    path:{
      type: String,
      default: null,
    },
    ignoreFields: {
      type: Array,
      default: () => [
        "businessScope",
        "trigger"
      ]
    },
    fromList: null,
  },
  computed: {
    errors() {
      return this.$store.state.errors;
    },
  },
  methods: {
    setSpecific(value, key) {
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: { ...this.instance, [key]: !!value }});
    }
  },
  created() {
    this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: { ...this.instance }});
  }
}
</script>
